// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  MetadataCategory,
} from "./types";

export default {
  versionId: __t.u64(),
  fileId: __t.u64(),
  key: __t.string(),
  value: __t.string(),
  get category() {
    return MetadataCategory;
  },
};
